<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="vol-1-epigraph">
<div class="text" id="vol-1-epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left epigraph-content">The truth is rarely pure and never simple</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content"><b><i>– Oscar Wilde</i></b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001epigraph.vue?d0f84d1a